module.exports = __webpack_public_path__ + "img/cup.609f8cac.svg";